module.exports = __webpack_public_path__ + "static/HKGrotesk-BoldItalic-74505b4c5efcf950ff5aee1aa457121c.woff";